import React from "react";
import {
  Select,
  SelectItem,
  SelectProps,
} from "@clarkinc/zest-design-system/ui";
import { generateQuantityOptions } from "~/features/shopping/utility/quantities";

interface QuantitySelectProps extends Omit<SelectProps, "onChange"> {
  minimumBuy: number;
  mustBuy: number;
  length?: number;
}

const QuantitySelect = ({
  minimumBuy,
  mustBuy,
  length = 15,
  ...rest
}: QuantitySelectProps) => (
  <Select {...rest}>
    {generateQuantityOptions(minimumBuy, mustBuy, length).map((option) => (
      <SelectItem value={option.toString()} key={option}>
        {option}
      </SelectItem>
    ))}
    <SelectItem value="other">Other</SelectItem>
  </Select>
);

export default QuantitySelect;
